import classNames from "classnames";
import style from "./StyledLink.module.scss";

export const StyledLink = ({
  icon,
  title,
  description,
  className,
  onClick,
  data,
}) => {
  const titleClass = classNames("semibold", "size-14", "epnb");
  const descriptionClass = classNames("regular", "size-12", "epnd");
  const rIcon = "LeftArrow";
  const iconClass = classNames(`tg-icons-${rIcon}`, "size-14");

  const itemContainerClass = classNames(
    style.itemContainer,
    style[className] ? style[className] : className
  );

  const dataAttributes = Object.keys(data).reduce((acm, key) => {
    acm[`data-${key}`] = data[key];
    return acm;
  }, {});

  return (
    <div className={itemContainerClass} onClick={onClick}>
      {icon ? (
        <div className={style.sectionIcon}>
          <i className={`tg-icons-${icon} size-24`}></i>
        </div>
      ) : null}
      <div className={style.section}>
        <h3 className={titleClass}>{title}</h3>
        <p className={descriptionClass}>{description}</p>
      </div>
      <button type="button" {...dataAttributes}>
        <i className={iconClass} onClick={onClick}></i>
      </button>
    </div>
  );
};
